import React from "react";
import { connect } from "react-redux";
// reactstrap components
import { Container } from "reactstrap";
import HeaderVideo from "../../assets/video/Header.mp4"
import { HOST_URL } from "../../utils/misc";

const IndexHeader = ({...props}) => {
  return (
    <>
    <div className="container-fluid p-0">
        <header>
            <div className="overlay"></div>
            <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop">
                <source src={HOST_URL + props.templates.templates.templateProperties.video_header} type="video/mp4" />
            </video>
            <div className="container h-100">
                <div className="content-center">
                    <Container>
                        <div className="title-brand">
                        <h1 className="presentation-title">{props.title}</h1>
                        </div>
                        <h2 className="presentation-subtitle text-center">
                        Hiện Đại - Sang Trọng - Tinh Tế
                        </h2>
                    </Container>
                </div>
                <div
                    className="moving-clouds"
                    style={{
                        backgroundImage: "url(" + require("assets/img/clouds.png") + ")",
                    }}
                />      
            </div>
        </header>
    </div>      
    </>
  );
}

const mapStateToProps = (state) => {
    return {
      products: state.products,
      templates: state.templates,
    };
  };
  
  export default connect(mapStateToProps)(IndexHeader);